// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eIfC","importantInfo":"styles_importantInfo__26cwV"};